import React, { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';
import SearchWidget from '../../shared/search/search-widget';
import { GetCities } from '../../../actions/cities';
import { withApollo } from 'react-apollo'; 
import { NewBooking, UpdateBookingStatus, FetchBooking, AddSector } from '../../../actions/booking';
import { AddPassenger } from '../../../actions/passenger';
import { connect } from 'react-redux';
import { getCyoaID } from '../../../helpers/cyoaHelper';
import { FetchCurrency } from '../../../actions/currency';
import { bindActionCreators } from 'redux';
import { history } from '../../App';
import { authToken } from '../../../actions/utils';

const queryString = require('query-string');



class AdventureSearchPage extends PureComponent {

    constructor(props){
        super(props);
        
        this.state = {
            activeCity:"",
            activeDate:""
        }
        
        this.cityClicked = this.cityClicked.bind(this);
        this.startDateClicked = this.startDateClicked.bind(this);
        this.onContinue = this.onContinue.bind(this);
    }

    componentDidMount(){

        const { client, cities } = this.props;
        const parsed = queryString.parse(window.location.search);
  
        //Fetch network cities
        if(cities === undefined) GetCities(client, getCyoaID(parsed));

        document.body.addEventListener('CITY_CLICK', this.cityClicked);
        document.body.addEventListener('CITY_START_DATE_CLICK', this.startDateClicked);
    }

    componentWillUnmount(){
        document.body.removeEventListener('CITY_CLICK', this.cityClicked);
        document.body.removeEventListener('CITY_START_DATE_CLICK', this.startDateClicked);
    }


    cityClicked(e){

        //Scroll into view
        ReactDOM.findDOMNode(this).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

        //save active city
        this.setState({activeCity: e.detail });
    }

    startDateClicked(e){
        //save active city
        this.setState({activeDate: e.detail });
    }

    async onContinue(){
        const { client, toggleView, currentBooking:{uuid}, isLoading, isBAB, FetchCurrency, onChangeView } = this.props;
        const { activeCity, activeDate } = this.state;
        const parsed = queryString.parse(window.location.search);

         //Add sector and toggle to builder view
         if(!isLoading){

            if(!isBAB){
                await AddSector(client, uuid, getCyoaID(parsed), "start", activeCity, 0, activeDate, activeCity);
                toggleView('builder');
            }else{                  
                const currencyCode = await FetchCurrency();
                await authToken();
                const bookingResponse = await NewBooking(client, currencyCode.data.currency_info.iso_currency_code, 'planner');
                await UpdateBookingStatus(client, bookingResponse.data.newBooking.uuid, 'build');
                await AddPassenger(client, bookingResponse.data.newBooking.uuid, 1);
                await FetchBooking(client, bookingResponse.data.newBooking.uuid);
                await AddSector(client, bookingResponse.data.newBooking.uuid, "CYO", "start", activeCity, 0, activeDate, activeCity);
                history.push(`/builder?id=${bookingResponse.data.newBooking.uuid}`);
                onChangeView("builder");
            }       
        }    
    }

    render(){

        const { activeCity, activeDate } = this.state;
        const { mapActive } = this.props;

        return(
            <Fragment>
                <div className="clearfix">
                    <div className={`${mapActive ? "col-12 sm-col-9 md-col-7 lg-col-12 px2 mx-auto" : "col-12 sm-col-9 md-col-7 px2 mx-auto" }`}>
                        <p className="medium f-size-20 margin-b-10">Let's get started!</p>
                        <p className="description-text margin-b-20">Choose destination, length of stay, add accommodation and bundle with other trips.</p>
                    </div>
                </div>

                <div className="clearfix">
                    <div className={`${mapActive ? "col-12 sm-col-9 md-col-7 lg-col-12 mx-auto" : "col-12 sm-col-9 md-col-7 mx-auto" }`}>
                        <SearchWidget isAdventurePlanner={true} />
                    </div>
                </div>

                <div className="clearfix">
                    <div className={`${mapActive ? "col-12 sm-col-6 md-col-4 lg-col-12 px2 mx-auto margin-t-40 margin-b-40" : "col-12 sm-col-6 md-col-4 px2 mx-auto margin-t-40 margin-b-40" }`}>
                        <button className="busabout--cta orange rounded-corner full-width" onClick={this.onContinue} disabled={activeCity && activeDate ? false : true}>Continue planning</button>
                    </div>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = state => {
    return{
        cities:state.cities.cities,
        currentBooking:state.currentBooking,
        isLoading:state.cart.update_sector_loading
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
      FetchCurrency
    }, dispatch);
  }

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(AdventureSearchPage));